import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icons } from "assets/icons";
import { Images } from "assets/images";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronUp } from "lucide-react";
import gsap from "utils/gsap";
import { useDispatch } from "react-redux";
import { setSideBarOpen } from "store/slices/commonSlice";

const SIDEBAR_ITEMS = [
  {
    module: "dashboard",
    label: "Dashboard",
    path: "/dashboards",
    icon: Icons.dashboard,
    iconHover: Icons.dashboard2,
  },
  // {
  //   module: "bookings",
  //   label: "Bookings",
  //   path: "/bookings",
  //   icon: Icons.dashboard,
  //   iconHover: Icons.dashboard2,
  // },
  // {
  //   module: "reports",
  //   label: "Reports",
  //   path: "/reports",
  //   icon: Icons.dashboard,
  //   iconHover: Icons.dashboard2,
  // },
  {
    module: "membership",
    permissionModules: [
      "membership_plan",
      "membership_addon",
      "dynamic_pricing_rule",
    ],
    label: "Membership",
    path: "/membership",
    icon: Icons.membership,
    iconHover: Icons.membership2,
    children: [
      {
        label: "Plans",
        path: "/membership/plans",
        module: "membership_plan",
        icon: Icons.plans,
        iconHover: Icons.plans2,
      },
      {
        label: "Addons",
        path: "/membership/addons",
        module: "membership_addon",
        icon: Icons.addon,
        iconHover: Icons.addon2,
      },
      {
        label: "Dynamic Prices Rule",
        path: "/dynamic-prices/list",
        module: "dynamic_pricing_rule",
        icon: Icons.dynamicPrices,
        iconHover: Icons.dynamicPrices2,
      },
    ],
  },

  {
    module: "branches",
    label: "Stores",
    path: "/stores",
    icon: Icons.stores,
    iconHover: Icons.stores2,
  },
  // {
  //   module: "localserver",
  //   label: "Store Camera",
  //   path: "/store-cameras",
  //   icon: Icons.storeCamera,
  //   iconHover: Icons.storeCamera1,
  // },
  {
    module: "vehicles",
    label: "Vehicles",
    path: "/vehicles",
    icon: Icons.vehicles,
    iconHover: Icons.vehicles2,
    children: [
      {
        module: "vehicles",
        label: "Make",
        path: "/vehicles/make",
        icon: Icons.vehicleMake,
        iconHover: Icons.vehicleMake2,
      },
      {
        module: "vehicles",
        label: "Model",
        path: "/vehicles/model",
        icon: Icons.vehicleModel,
        iconHover: Icons.vehicleModel2,
      },
      {
        module: "vehicles",
        label: "Color",
        path: "/vehicles/color",
        icon: Icons.vehicleColor,
        iconHover: Icons.vehicleColor2,
      },
    ],
  },
  {
    module: "wash_history",
    label: "Wash History",
    path: "/wash-history",
    icon: Icons.washHistory,
    iconHover: Icons.washHistory2,
  },
  {
    module: "roles",
    label: "Roles",
    path: "/roles",
    icon: Icons.roles,
    iconHover: Icons.roles2,
  },
  {
    module: "users",
    label: "Users",
    path: "/users",
    icon: Icons.users,
    iconHover: Icons.users2,
  },
  {
    module: "customers",
    label: "Customers",
    path: "/customers",
    icon: Icons.customers,
    iconHover: Icons.customers2,
    children: [
      {
        label: "Customer List",
        path: "/customers",
        module: "customers",
        icon: Icons.customerList,
        iconHover: Icons.customerList2,
      },
      {
        label: "Leads",
        path: "/leads",
        module: "notifications",
        icon: Icons.leads,
        iconHover: Icons.leads2,
      },
     
    ],
  },
  {
    module: "notifications",
    permissionModules: ["notifications"],
    label: "Notification",
    path: "/notification",
    icon: Icons.notification,
    iconHover: Icons.notification2,
    children: [
      {
        label: "Push Notification",
        path: "/notification/push-notification",
        module: "notifications",
        icon: Icons.plans,
        iconHover: Icons.plans2,
      },
      {
        label: "Rules",
        path: "/notification/rules",
        module: "notifications",
        icon: Icons.rules,
        iconHover: Icons.rules2,
      },
      {
        label: "History",
        path: "/notification/history",
        module: "notifications",
        icon: Icons.history,
        iconHover: Icons.history2,
      },
    ],
  },
  {
    module: "banners",
    label: "Banners",
    path: "/banners",
    icon: Icons.banners,
    iconHover: Icons.banners2,
  },
  {
    module: "coupon",
    label: "Coupons",
    path: "/coupons",
    icon: Icons.coupons,
    iconHover: Icons.coupons2,
  },
  {
    module: "report",
    label: "Reports",
    path: "/reports",
    icon: Icons.reportsIcon,
    iconHover: Icons.reportsIcon2,
    children: [
      {
        module: "report",
        label: "Transactions",
        path: "/reports-transactions",
        icon: Icons.transactionsIcon,
        iconHover: Icons.transactionsIcon2,
      },
    ],
  },
  {
    module: "settings",
    label: "Global settings",
    path: "/settings",
    icon: Icons.settings,
    iconHover: Icons.settings2,
  },
  {
    module: "api_logs",
    label: "Logs",
    path: "/logs",
    icon: Icons.logs,
    iconHover: Icons.logs2,
    children: [
      {
        module: "api_logs",
        label: "API Logs",
        path: "/api-logs",
        icon: Icons.apiLogs,
        iconHover: Icons.apiLogs2,
      },
      {
        label: "ANPR Logs",
        path: "/anpr-logs",
        icon: Icons.anprLogs,
        iconHover: Icons.anprLogs2,
      },
      {
        label: "Audit Logs",
        path: "/audit-logs",
        icon: Icons.auditLogs,
        iconHover: Icons.auditLogs2,
      },
      {
        label: "Barrier Control Logs",
        path: "/barrier-control-logs",
        icon: Icons.barrierControlLogs,
        iconHover: Icons.barrierControlLogs2,
      },
      {
        label: "POS Activities",
        path: "/pos-activities",
        icon: Icons.kioskActivities,
        iconHover: Icons.kioskActivities2,
      },
    ],
  },

  {
    label: "Profile",
    path: "/profile",
    icon: Icons.profile,
    iconHover: Icons.profile2,
  },
];

const AdminSidebar = ({ className = "" }) => {
  const dispatch = useDispatch();
  const { accountType, rolePermissions } = useSelector((state) => state.Auth);
  const { isSideBarOpen } = useSelector((state) => state.CommonActions);

  const [openMenu, setOpenMenu] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false); // ADD THIS LINE
  const location = useLocation();
  const { t } = useTranslation();

  const { logo } = Images || {};
  const { logout, sideBarCollapseOpen, sideBarCollapseClose } = Icons || {}; // ADD sidebarCollapse

  const menuRef = useRef(null);
  const logoutRef = useRef(null);

  // Close sidebar on mobile when link is clicked
  const handleLinkClick = () => {
    const isMobile = window.innerWidth <= 992;
    if (isMobile && isSideBarOpen) {
      dispatch(setSideBarOpen(false));
    }
  };

  // CHECK USER PERMISSION AND SHOW/HIDE SIDEBAR LINKS
  const allowedModules =
    accountType === "superadmin" || rolePermissions?.hasFullPermission
      ? SIDEBAR_ITEMS.flatMap((item) =>
          item.permissionModules?.length ? item.permissionModules : item.module,
        )
      : (rolePermissions?.permissions || []).map((p) => p.module);

  // Filter items based on permission
  const visibleItems = SIDEBAR_ITEMS.filter((item) => {
    if (item.path === "/profile") return true;
    if (!item.permissionModules) {
      return allowedModules.includes(item.module);
    }
    return item.permissionModules.some((m) => allowedModules.includes(m));
  });

  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleDropdown = (module) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [module]: !prev[module],
    }));
  };
  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev);
  };

  useEffect(() => {
    // Auto-open parent dropdown if any child is active
    visibleItems.forEach((item) => {
      if (item.children && isChildActive(item.children)) {
        setOpenDropdowns((prev) => ({
          ...prev,
          [item.module]: true,
        }));
      }
    });
  }, [location.pathname]);

  // ANIMATIONS
  useEffect(() => {
    if (!menuRef.current || !logoutRef.current) return;
    const items = menuRef.current.children;
    gsap.fromTo(
      items,
      {
        opacity: 0,
        x: -12,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.35,
        ease: "power2.out",
        stagger: 0.06,
        onComplete: () => {
          gsap.fromTo(
            logoutRef.current,
            { opacity: 0, y: 8 },
            {
              opacity: 1,
              y: 0,
              duration: 0.25,
              ease: "power2.out",
            },
          );
        },
      },
    );
  }, []);

  const isActive = (path) =>
    location.pathname.startsWith(path) ? "active" : "";
  const toggleMenu = (module) => {
    setOpenMenu(openMenu === module ? null : module);
  };
  const isChildActive = (children = []) =>
    children.some((child) => location.pathname.startsWith(child.path));

  return (
    <div
      className={`sidebar_menu ${isCollapsed ? "collapsed" : ""} ${className}`}
      id="sidebar_menu"
    >
      {" "}
      {/* Logo */}
      {/* Logo */}
      <div className="g_between main_div">
        <Link to="/dashboards" className="sidebar_logo">
          <img
            src={logo}
            alt="Logo"
            width={isCollapsed ? 60 : 100}
            height={55}
          />
        </Link>

        {/* ADD THIS TOGGLE BUTTON */}
        <button
          className="sidebar-toggle-btn"
          onClick={toggleSidebar}
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? (
            <img
              src={sideBarCollapseOpen}
              alt="Expand"
              width={24}
              height={24}
            />
          ) : (
            <img
              src={sideBarCollapseClose}
              alt="Collapse"
              width={24}
              height={24}
            />
          )}
        </button>
      </div>
      {/* Sidebar Menu */}
      <nav id="sidebar-menu">
        <ul className="p-0" ref={menuRef}>
          {visibleItems.map((item, index) => (
            <li key={index}>
              {item.children ? (
                <>
                  <div
                    className={`dropdown-trigger ${isActive(item.path)} ${
                      isChildActive(item.children) ? "active" : ""
                    }`}
                    onClick={() => toggleDropdown(item.module)}
                  >
                    <img
                      src={item.icon}
                      className="main_icon"
                      width={20}
                      alt=""
                      height={20}
                    />
                    <img
                      src={item.iconHover}
                      className="hover_icon"
                      width={20}
                      alt=""
                      height={20}
                    />
                    <span className="label_name">{t(item.label)}</span>{" "}
                    {openDropdowns[item.module] ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </div>
                  {openDropdowns[item.module] && (
                    <ul className="sub-dropdown-menu">
                      {item.children
                        .filter(
                          (child) =>
                            rolePermissions?.hasFullPermission ||
                            allowedModules.includes(child.module),
                        )
                        .map((child, childIndex) => (
                          <li key={childIndex}>
                            <Link
                              to={child.path}
                              className={isActive(child.path)}
                              onClick={handleLinkClick}
                            >
                              <img
                                src={child.icon}
                                className="main_icon"
                                width={20}
                                alt=""
                                height={20}
                              />
                              <img
                                src={child.iconHover}
                                className="hover_icon"
                                width={20}
                                alt=""
                                height={20}
                              />
                              <span className="label_name">
                                {t(child.label)}
                              </span>
                            </Link>
                          </li>
                        ))}
                    </ul>
                  )}
                </>
              ) : (
                <Link
                  to={item.path}
                  className={isActive(item.path)}
                  onClick={handleLinkClick}
                >
                  <img
                    src={item.icon}
                    className="main_icon"
                    width={20}
                    alt=""
                    height={20}
                  />
                  <img
                    src={item.iconHover}
                    className="hover_icon"
                    width={20}
                    alt=""
                    height={20}
                  />
                  <span className="label_name">{t(item.label)}</span>{" "}
                </Link>
              )}
            </li>
          ))}
        </ul>
        <div
          className="g_between logout_wrapper position-relative"
          ref={logoutRef}
          style={{ opacity: 0 }}
        >
          <h4>{t("Logout")}</h4>
          <Link
            to={"/logout"}
            className="logout_link"
            onClick={handleLinkClick}
          >
            <img src={logout} alt="logout" width={25} height={25} />
          </Link>
        </div>
      </nav>
    </div>
  );
};

export default AdminSidebar;
